import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { CandidateListComponent } from "./candidate-list/candidate-list.component";
import { CandidateComponent } from './candidate/candidate.component';
import { NotificationService } from '../../shared/notification.service';
import { CandidateService } from '../../shared/candidate.service';
import { AppComponent } from 'src/app/app.component';
import { MaterialModule } from 'src/app/material/material.module';
import { CandidatesComponent } from './candidates.component';
import { UploadExcelComponent } from './upload-excel/upload-excel.component';
import { GlobalConstantsService } from 'src/app/shared/global-constants.service';

@NgModule({
  declarations: [
    CandidatesComponent,
    CandidateComponent, 
    CandidateListComponent, 
    UploadExcelComponent
  ],
  imports: [
    CommonModule,
    MaterialModule
  ],
  providers: [
    CandidateService,
    NotificationService,
    GlobalConstantsService
  ],
  bootstrap: [AppComponent],
  entryComponents:[CandidateComponent, UploadExcelComponent]
})
export class CandidatesModule {}
